import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paper: {
    borderTop: `4px solid ${theme.palette.error.main}`,
    borderRadius: 8,
  },
  content: {
    padding: theme.spacing(3, 3, 2),
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  description: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(0, 3, 3),
  },
  continueButton: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    borderColor: theme.palette.text.primary,
  },
  cancelButton: {
    fontWeight: 700,
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
  },
}))

export default useStyles
